import React from 'react';

import type { Icon } from '@atlaskit/editor-common/extensions';

/** Lazy-load the Rovo icon, sharing the chunk across all manifest icon entries. */
const loadAgentManagedExtensionIcon = (): Promise<{
	default: React.ComponentType<{ label: string; size?: 'small' | 'medium' | 'large' | 'xlarge' }>;
}> =>
	import(
		/* webpackChunkName: "@atlaskit-internal_editor-agent-managed-extension-icon" */
		'@atlassian/generative-ai-modal/assets/RovoIcon'
	);

/** Build a manifest-shaped icon loader that renders the Rovo icon at the given size. */
export const getAgentManagedExtensionIconLoader =
	(label: string, size: 'small' | 'medium' = 'medium'): Icon =>
	() =>
		loadAgentManagedExtensionIcon().then((mod) => {
			const RovoIcon = mod.default;
			const IconForManifest = () => <RovoIcon label={label} size={size} />;
			IconForManifest.displayName = 'AgentManagedExtensionManifestIcon';
			return IconForManifest;
		});
